/**
 * @generated SignedSource<<340776c7005435f54cad8a3baa6755f8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProductDetailsRowText$data = {
  readonly label: string;
  readonly subTitle: string | null;
  readonly text: string | null;
  readonly " $fragmentType": "ProductDetailsRowText";
};
export type ProductDetailsRowText$key = {
  readonly " $data"?: ProductDetailsRowText$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProductDetailsRowText">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProductDetailsRowText",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "text",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "label",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subTitle",
      "storageKey": null
    }
  ],
  "type": "ProductInfoComponentTextRow",
  "abstractKey": null
};

(node as any).hash = "528b6d317cd38c58efe50c144d0ac7cc";

export default node;
